<template>
  <div :class="'navbar-container d-flex content align-items-center' + FadeBackground()">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
            class="nav-link"
            @click="toggleVerticalMenuActive"
        >
          <feather-icon
              icon="MenuIcon"
              size="21"
          />
        </b-link>
      </li>
    </ul>
    <b-button
        size="sm"
        class="ml-2 btn-success"
        @click="OpenDispoToDay"
    >
      DH
    </b-button>
    <b-dropdown
        variant="warning"
        size="sm"
        :text="'Letzer Ruf: ' + (lastCalls[0] !=  null && lastCalls[0].Number != null ? lastCalls[0].Number : '-')  "
    >
      <b-dropdown-item
          style="width: 40vh"
          v-for="c in lastCalls"
      >
        <b-row>
          <b-col
              cols="9"
              @click="CopyText(c.Number)"
          >
            <h5>{{ c.Number }}</h5>
            <h6>{{ formatDateAndTime(c.DateTime) }}</h6>
          </b-col>
          <b-col
              cols="3"
          >
            <b-button
              class="w-100"
            @click="OpenNoteMenu('Call'+c.Number)">
              <feather-icon icon="PenToolIcon"/>

            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-badge
              variant="danger"
              class="w-100"
              v-for="d in c.Drivers"
          >
            {{ d.Name }}
          </b-badge>
          <b-badge
              class="w-100"
              variant="warning"
              v-for="d in c.Addresses"
          >
            {{ d.IdentId }} - {{ d.Name }}
          </b-badge>
          <b-badge
              class="w-100"
              variant="secondary"
              v-for="d in c.Customer"
          >
            {{ d.IdentId }} - {{ d.Name }}
          </b-badge>
          <b-badge
              class="w-100"
              variant="danger"
              v-for="d in c.Contacts"
          >
            {{ d.IdentId }} - {{ d.Name }}
          </b-badge>
        </b-row>
        <b-row>
          <hr>
        </b-row>
      </b-dropdown-item>
    </b-dropdown>

    <b-dropdown
        class="ml-1"
        size="sm"
        variant="flat-dark"
        style="background-color: #1a282a; color: white"
        :text="'Online-Buchungen: ' + Object.keys(UnconfirmedOnlineVouchers).length "
    >
      <div class="scrollableOnlineBookings">
        <b-dropdown-item
            v-for="v in UnconfirmedOnlineVouchers"
            @click="OpenVoucher(v.Vid)"
        >
          <b-badge :variant="v.WarningCode == 0 ? 'success' : v.WarningCode == 1 ? 'warning' : 'danger'">
            V{{ v.Vid }}
          </b-badge>
          -
          <b-badge variant="info">
            [{{ v.Customer.CustomerNumber }}] {{ v.Customer.CustomerName }}
          </b-badge>
          <br>
          {{ v.PickUpAddressContact.Name }} => {{ v.DestinationAddressContact.Name }}<br>
          <span style="font-size: 1.2vh">{{ formatDate(v.TravelDay) }} (Erstellt: {{ formatDate(v.CreatedTime) }} )</span>
          <hr>
        </b-dropdown-item>
      </div>
    </b-dropdown>
    <b-navbar-nav class="nav align-items-center ml-auto">
      <div class="mr-1">
        <b-badge :variant="mailState ? 'success' : 'danger'">
          Mail / PDF: {{ mailState ? 'Verbunden' : 'Offline' }}
        </b-badge>
      </div>
      <div class="mr-3">
        <b-badge :variant="ping >= 0 ? 'success' : 'danger'">
          {{ ping >= 0 ? 'Ping:&emsp;' + ping + 'ms' : 'Server nicht erreichbar' }}
        </b-badge>
      </div>
      <div class="mr-1">
        <b-badge>
          {{ userCount >= 0 ? userCount : 0 }}
        </b-badge>
      </div>
      <b-nav-item-dropdown
          right
          toggle-class="d-flex align-items-center dropdown-user-link"
          class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ GetAccountName() }}
            </p>
            <span class="user-status">{{ GetAccountType() }}</span>
          </div>
          <b-avatar
              size="40"
              variant="light-primary"
              badge
              class="badge-minimal"
              badge-variant="success"
          />
        </template>

        <b-dropdown-item link-class="d-flex align-items-center"
                         @click="Account"
        >
          <feather-icon
              size="16"
              icon="UserIcon"
              class="mr-50"
          />
          <span>Account</span>
        </b-dropdown-item>

        <b-dropdown-divider/>

        <b-dropdown-item link-class="d-flex align-items-center"
                         @click="logout"
        >
          <feather-icon
              size="16"
              icon="LogOutIcon"
              class="mr-50"
          />
          <span>Abmelden</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
    <note ref="note" />
    <FtFile ref="ftFile" />
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar, BBadge, BDropdown, BButton, BFormInput, BPagination, BFormSelect, BCol, BFormGroup, BInputGroupAppend, BInputGroup, BRow, BTable, BAlert, BFormCheckbox
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import * as constants from 'constants'
import Note from '@/views/notepad/note.vue'
import FtFile from '@/views/administration/FtFile.vue'

export default {
  components: {
    Note,
    FtFile,
    BFormCheckbox,
    BAlert,
    BTable,
    BRow,
    BInputGroup,
    BInputGroupAppend,
    BFormGroup,
    BCol,
    BFormSelect,
    BPagination,
    BFormInput,
    BButton,
    BDropdown,
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BBadge,
    // Navbar Components
    DarkToggler,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {
      },
    },
  },

  data() {
    return {
      pingTime: Date.now(),
      ping: -1,
      userCount: 0,
      lastCalls: [],
      UnconfirmedOnlineVouchers: [],
      mailState: false,
      serverLost: null,
      offlineSwal: null,
      pingTimeout: null
    }
  },
  mounted() {
    this.$root.$on('OpenNoteMenu', this.OpenNoteMenu) // Ereignis registrieren
    this.$root.$on('OpenFileMenu', this.OpenFileMenu) // Ereignis registrieren
  },
  sockets: {
    connect() {
      console.log('socket connected')
      this.$socket.emit('authSocketUser', { jwt: this.$cookies.get('jwt') })
      console.log(this.serverLost)
      if (this.offlineSwal != null) {
        this.$swal(this.offlineSwal)
            .close()
        this.offlineSwal = null
      }
      this.SendPing()
    },
    HasFullAdminRights() {
      return this.$store.state.user.Rights.includes('2')
    },

    disconnect() {
      this.ping = -1
      if (!this.HasFullAdminRights()) {

        this.offlineSwal = this.$swal({
          title: 'Keine Verbindung!',
          html: '<div style="color: white" class="fade-in-out">Warten auf verbindung....</div>',
          icon: 'warning',
          allowEscapeKey: false,
          allowEnterKey: false,
          allowOutsideClick: false,
          backdrop: `
          rgba(47,47,47,0.6)
          left top
          no-repeat
        `,
          background: '#790000',
          showCancelButton: false,
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })
            .then(result => {
              if (result.isConfirmed) {
              }
            })
      }
    },
    OnlineCount(data) {
      this.userCount = data
    },
    LastCalls(data) {
      this.lastCalls = data
      console.log(data)
    },
    UnconfirmedOnlineVouchers(data) {
      this.UnconfirmedOnlineVouchers = data
    },
    pong2(data) {

      data = JSON.parse(data)
      this.mailState = data.MailConnected
      this.ping = Date.now() - this.pingTime
      const v = this
      // this.$store.dispatch('SET_CALLCOUNT', callCount).then()
      clearTimeout(this.pingTimeout)
      this.pingTimeout = setTimeout(() => {
        v.SendPing()
      }, 8000)
    },
  },
  methods: {
    OpenNoteMenu(groupId) {
      this.$refs.note.OpenEditMenu(groupId);
    },
    OpenFileMenu(targetType, targetId) {
      this.$refs.ftFile.OpenMenu(targetType, targetId);
    },
    LoadCallMenu() {
      console.log(this.lastCalls[this.lastCalls.length])
    },
    OpenDispoToDay() {

      const today = new Date()
      const year = today.getFullYear()
      const month = today.getMonth() + 1
      const day = today.getDate()

      const formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`

      this.$router.push({ name: 'Blank' })
      this.$nextTick(() => this.$router.push({
        name: 'Disposition',
        params: { day: formattedDate }
      }))

    },
    OpenVoucher(vid) {

      this.$router.push({ name: 'Blank' })

      this.$nextTick(() => this.$router.push({
        name: 'VoucherMask',
        params: { id: vid }
      }))

    },
    formatDate(date) {
      return `${new Date(date).toLocaleString('de-DE', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          },
      )}`
    },
    async CopyText(mytext) {
      try {
        await navigator.clipboard.writeText(mytext)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Kopiert',
            icon: 'CheckIcon',
            text: 'Text ist nun in der Zwischenablage',
            variant: 'info',
          },
        })
      } catch ($e) {
      }
    },
    formatDateAndTime(date) {
      return `${new Date(date).toLocaleString('de-DE', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          },
      )}`
    },
    FadeBackground() {
      return (window.location.host == 'localhost:8080' ? ' fade-background' : '')
    },
    GetLastCall() {
      this.$router.push({ name: 'LastCall' })
    },
    GetAccountName() {
      return this.$store.state.user.Username
    },
    GetAccountType() {
      return this.$store.state.user.UserType

    },
    Account() {
      this.$router.push({ name: 'Account' })
    },
    async logout() {
      await this.$store.dispatch('LOGOUT')
          .then()
      this.$router.push({ name: 'login' })
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Abmeldung',
          icon: 'CheckIcon',
          text: 'Sie wurden abgemeldet.',
          variant: 'success',
        },
      })

    },
    SendPing() {
      this.pingTime = Date.now()
      this.$socket.emit('ping2', { agent: btoa(navigator.userAgent) })
    },
  },
}
</script>

<style>
.fade-background {
  background-color: #216296;
  animation: color-change 1200ms ease-in-out infinite alternate;
}

@keyframes color-change {
  0% {
    filter: brightness(70%);
  }
  50% {
    filter: brightness(120%);
  }
  100% {
    filter: brightness(70%);
  }
}

.scrollableOnlineBookings {
  height: 60vh; /* Höhe des scrollbaren Bereichs auf 70% der Bildschirmhöhe festlegen */
  overflow-y: auto; /* Sichtbarkeit der vertikalen Scrollbar aktivieren */
}

/* Styling der Scrollbar */
::-webkit-scrollbar {
  width: 10px;
}

/* Styling des Scrollbar-Thumb */
::-webkit-scrollbar-thumb {
  background-color: #999;
  border-radius: 10px;
}

/* Styling des Scrollbar-Thumb beim Hovern */
::-webkit-scrollbar-thumb:hover {
  background-color: #666;
}

.fade-in-out {
  animation: fadeInOut 1.5s ease-in-out infinite;
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>